<template>
  <div class="products-page">
    <v-header></v-header>
    <user-info :avatar="userInfo.avatar" :user-name="userInfo.account_name">
      <span v-if="isPortrait" class="info-tips">請選擇您要儲值的商品</span>
      <span class="info-tips" :class="[isPortrait ? 'tips-spec' : false]">
        餘額：
        <span class="wallet-overage">
          <span>{{userInfo.wallet}}</span>
          <span class="wallet-suffix">G幣</span>
        </span>
      </span>
    </user-info>
    <div class="product-list">
      <div class="type-select">
        <span
          @click="selectType('coin')"
          class="type-select_item j-points-select-dcount"
          :class="[productType === 'coin' ? 'active' : false]"
        >遊戲幣</span>
        <span
          @click="selectType('package')"
          class="type-select_item j-package-select-dcount"
          :class="[productType === 'package' ? 'active' : false]"
        >禮包</span>
      </div>
      <transition-group name="list-change" tag="div" class="list-change-cover">
        <div
          :key="product.catalog"
          class="product-content"
          v-for="product in products"
          v-show="productType === product.catalog"
        >
          <template v-if="product.list.length">
            <div
              :key="item.PRODUCT_ID"
              class="product-content_item"
              @click="selectProduct(item)"
              v-for="item in product.list"
              :class="[item.PRODUCT_ID === curProduct.PRODUCT_ID ? 'active' :false]"
            >
              <img class="product-content_item-icon" :src="item.icon" alt="icon" />
              <div class="product-content_item-detail">
                <p class="product-content_item-desc">{{item.desc}}</p>
                <p
                  class="product-content_item-extra"
                  v-if="item.PRODUCT_EXTRA_DESC"
                >{{item.PRODUCT_EXTRA_DESC}}</p>
              </div>
              <div class="product-content_item-price">{{item.COST_POINTS}}&nbsp;G幣</div>
            </div>
          </template>
          <template v-else>
            <div class="product-content_empty">該分類暫無可購買商品哦~</div>
          </template>
        </div>
      </transition-group>
    </div>
    <div class="confirm-btn j-jump-next-dcount" @click="jumpToProductConfirm">下一步</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isEmptyObj } from '@/utils'
import vHeader from '@/components/header'
import userInfo from '@/components/user-info'
import defaultCoin from '@/assets/default-coin.png'
import defaultPackage from '@/assets/default-package.png'
export default {
  name: 'Products',
  components: { vHeader, userInfo },
  data () {
    return {
      productType: 'coin',
      products: [],
      curProduct: {}
    }
  },
  computed: {
    ...mapGetters({ userInfo: 'getUserInfo', isPortrait: 'getDeviceDirection' })
  },
  methods: {
    jumpToProductConfirm () {
      if (isEmptyObj(this.curProduct)) {
        this.$store.commit('setTipsState', true)
        this.$store.commit('setTipsContent', '請選擇購買商品')
        return
      }
      this.$router.push({
        name: 'order',
        query: {
          icon: this.curProduct.icon,
          pId: this.curProduct.PRODUCT_ID,
          cpId: this.curProduct.CP_PRODUCT_ID,
          currency: this.curProduct.BOSS_CURRENCY,
          product: JSON.stringify(this.curProduct)
        }
      })
    },
    selectType (type) {
      this.curProduct = {}
      this.productType = type
    },
    selectProduct (data) {
      this.curProduct = data
    },
    fetchProducts () {
      let params = this.userInfo
      this.$jsonp('//mstore.gm99.com/points/show_game_product', params)
        .then(res => {
          let data = res.data
          if (+res.result >= 1) {
            let hasCoin = data
              ? data.findIndex(item => item.catalog === 'coin') >= 0
              : false
            let hasPackage = data
              ? data.findIndex(item => item.catalog === 'package') >= 0
              : false
            if (!hasCoin) {
              data.push({ catalog: 'coin', list: [] })
            }
            if (!hasPackage) {
              data.push({ catalog: 'package', list: [] })
            }
            this.products = data.map(item => {
              let isCoin = item.catalog === 'coin'
              let defaultIcon = isCoin ? defaultCoin : defaultPackage
              item.list = item.list.map(obj => {
                obj.icon =
                  obj.CP_PRODUCT_ICON || obj.PRODUCT_ICON || defaultIcon
                obj.desc = obj.CP_PRODUCT_DESC || obj.PRODUCT_DESC
                return obj
              })
              return item
            })
          } else {
            this.$store.commit('setTipsState', true)
            this.$store.commit('setTipsContent', res.msg)
          }
          this.$store.commit('setLoadingState', false)
        })
        .catch(err => {
          this.$store.commit('setTipsState', true)
          this.$store.commit('setTipsContent', err.message || '系統錯誤')
        })
    }
  },
  created () {
    if (!this.userInfo.role_id) {
      this.$router.replace({ name: 'game' })
      return
    }
    this.fetchProducts()
  }
}
</script>

<style lang="scss" scoped>
.products-page {
  overflow: auto;
  text-align: left;
  min-height: 100%;
  overflow-x: hidden;
  padding-bottom: 60px;
  box-sizing: border-box;
  background-color: #f4f4f4;
  .tips-spec {
    text-align: right;
    display: inline-block;
    width: calc(100% - 135px);
  }
  .wallet-overage {
    font-size: 22px;
    color: #e97d30;
  }
  .wallet-suffix {
    font-size: 13px;
  }
  .product-list {
    margin-top: 10px;
    background-color: #fff;
    .type-select {
      padding: 5px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      border-bottom: 1px solid #e5e5e5;
      &_item {
        flex: 1;
        height: 38px;
        width: 49%\9;
        display: inline-block\9;
        cursor: pointer;
        font-size: 15px;
        color: #6d6d6d;
        line-height: 38px;
        text-align: center;
        position: relative;
        transition: color 0.8s;
        &:first-child {
          border-right: 1px solid #e5e5e5;
        }
        &.active {
          color: #333;
          font-weight: 700;
        }
        &:after {
          left: 50%;
          width: 83px;
          content: " ";
          bottom: -4px;
          display: block;
          padding-top: 0;
          position: absolute;
          transition: all 0.8s;
          background-color: transparent;
          transform: translate3d(-50%, 0, 0);
          transform: translate(-50%, 0) \9;
        }
        &.active:after {
          padding-top: 3.5px;
          background-color: #e97d30;
        }
      }
    }
    .list-change-cover {
      width: 200%;
      overflow: hidden;
    }
    .product-content {
      float: left;
      width: 50%;
      padding: 10px 0;
      box-sizing: border-box;
      &_empty {
        display: flex;
        height: 257px;
        font-size: 15px;
        color: #9c9c9c;
        align-items: center;
        justify-content: center;
        text-align: center\9;
        padding-top: 106px\9;
        box-sizing: border-box;
      }
      &_item {
        height: 63px;
        display: flex;
        padding: 0 17px;
        align-items: center;
        transition: all 0.3s;
        background-color: transparent;
        justify-content: space-between;
        border-bottom: 1px solid #ebebeb;
        &.active {
          border-color: #ffede1;
          background-color: #ffede1;
        }
        &-icon {
          width: 48px;
          height: 48px;
          margin-top: 7px\9;
          background-size: 100% 100%;
          vertical-align: middle\9;
          display: inline-block\9;
        }
        &-detail {
          flex: 1;
          padding-left: 15px;
          box-sizing: border-box;
          width: calc(100% - 198px) \9;
          vertical-align: middle\9;
          display: inline-block\9;
          p {
            margin: 0;
            padding: 0;
          }
        }
        &-desc {
          color: #333;
          font-size: 13px;
          font-weight: 700;
        }
        &-extra {
          margin-top: 3px;
          font-size: 11px;
          color: #6d6d6d;
        }
        &-price {
          font-size: 17px;
          color: #e97d30;
          text-align: right\9;
          width: 150px\9;
          vertical-align: middle\9;
          display: inline-block\9;
        }
      }
    }
  }
  .confirm-btn {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 50px;
    color: #fff;
    cursor: pointer;
    line-height: 50px;
    text-align: center;
    background-color: #e97d30;
  }
}
@media screen and (orientation: landscape) {
  .products-page {
    .product-list {
      margin-top: 0;
    }
  }
}
.list-change-move {
  transition: all 0.8s;
}
.list-change-enter {
  opacity: 0;
}
.list-change-leave-active {
  display: none;
}
</style>
